/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Route, Routes, useLocation} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import ResetPassword from './components/ResetPassword'
import {OnboardingPaymentSuccess} from './components/OnboardingPaymentSuccess'
import {OnboardingPaymentFailed} from './components/OnboardingPaymentFailed'

const AuthLayout = () => {
  
  useEffect(() => {
    document.body.classList.add('bg-body')
    
    // Function to update auth container theme
    const updateAuthTheme = () => {
      const authContainer = document.getElementById('kt_login')
      if (authContainer) {
        authContainer.setAttribute('data-theme', document.documentElement.getAttribute('data-theme') || 'light')
      }
    }
    
    // Set initial theme
    updateAuthTheme()
    
    // Listen for theme changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-theme') {
          updateAuthTheme()
        }
      })
    })
    
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    })
    
    return () => {
      document.body.classList.remove('bg-body')
      observer.disconnect()
    }
  }, [])

  return (
    <>
      <div id='login-root'>
        <div className='d-flex flex-column flex-root'>
          <div
            className='login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-body'
            id='kt_login'
          >
            <div
              className='login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10'
              style={{
                backgroundImage: `url(${toAbsoluteUrl('/media/auth/login-bg.jpg')})`,
              }}
            >
              <div className='d-flex flex-row-fluid flex-column justify-content-between'>
                <a href='https://singlelogin.io/' className='flex-column-auto mt-5'>
                  <img alt='Logo' className='max-h-50px' src='/media/logos/single-login.png' />
                </a>
                <div className='mt-2 flex-column-fluid d-flex flex-column justify-content-center'>
                  <h3 className='font-size-h1 text-white mb-1'>Welcome to Single Sign In</h3>
                  <span className='text-white'>Multi Tenant System</span>
                </div>
                <div
                  id='fadeshow1'
                  className='d-none flex-column-auto d-lg-flex justify-content-between mt-10'
                >
                  <div className='opacity-70 font-weight-bold text-white'>© 2022 SingleLogin</div>
                  <div className='d-flex'>
                    <a href='https://singlelogin.io/' className='text-white'>
                      Privacy&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </a>
                    <span> </span>
                    <a href='https://singlelogin.io/' className='text-white'>
                      Legal&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </a>
                    <a href='https://singlelogin.io/' className='text-white'>
                      Contact
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className='flex-row-fluid d-flex flex-column position-relative pb-0 pl-7 pt-7 pr-7 overflow-hidden'>
              <div className='d-flex flex-column-fluid flex-center mt-30 mt-lg-0'>
                <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
                  {/* begin::Content */}
                  <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const AuthPage = () => {
  const location = useLocation()

  // Check if current path contains "authenticatemodule" but don't redirect
  if (location.pathname.toLowerCase().includes('authenticatemodule')) {
    // Instead of redirecting, render the Login component directly
    // This preserves the URL while showing the login page
    return (
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path='*' element={<Login />} />
        </Route>
      </Routes>
    )
  }
  // Check for onboarding - redirect to Registration
  if (location.pathname.toLowerCase().includes('/auth/registration/onboarding/payment')) {
    return (
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path='payment-success' element={<OnboardingPaymentSuccess />} />
          <Route path='payment-failed' element={<OnboardingPaymentFailed />} />
        </Route>
      </Routes>
    )
  } else if (location.pathname.toLowerCase().includes('/auth/registration/onboarding')) {
    return (
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path='*' element={<Registration />} />
        </Route>
      </Routes>
    )
  }

  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path='login' element={<Login />} />
        <Route path='reset_password' element={<ResetPassword />} />
        <Route path='registration' element={<Registration />} />
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route index element={<Login />} />
        <Route path='invite/:id' element={<Login />} />
        <Route path='registration/:id' element={<Registration />} />
        <Route path='registration/inviteuser/:id' element={<Registration />} />
        <Route path='login/inviteuser/:id' element={<Login />} />
      </Route>
    </Routes>
  )
}
export {AuthLayout}
export {AuthPage}
